import { AxiosError } from 'axios';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import UnsavedChangesModal from '../../../common/UnsavedChangesModal/UnsavedChangesModal';
import { showToast } from '../../../components/Toast/Toast';
import { ToastTypes } from '../../../components/Toast/Toast.types';
import { useAddManInvRawProd, useManInvRawProds } from '../../../services/manInv/manInv.service';
import { ManInvRawProds } from '../../../services/manInv/manInv.types';
import { genericErrorShowToastOptions } from '../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import ManInvRawProdForm from '../ManInvRawProdForm/ManInvRawProdForm';
import { ManInvRawProdValues } from '../ManInvRawProdForm/ManInvRawProdForm.types';

const AddManInvRawProd: FC = () => {
  
  const { data: rawProdData } = useManInvRawProds(true);
  const { mutate, isLoading: isSaveLoading, } = useAddManInvRawProd();
  const navigateWithToast = useNavigateWithToast();
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [formValues, setFormValues] = useState<ManInvRawProdValues>({
    frequencyNo: '',
    conceptNo: '',
    manInvRawProdId: '',
  });

  const rawProdOptions =
    rawProdData?.data?.map((item: ManInvRawProds) => {
      return { value: item?.id?.toString(), label: `${item?.description} ~ ${item.id}` };
    }) || [];

  const checkForUnsavedChanges = () => {
    if (formValues.frequencyNo !== '' || formValues.manInvRawProdId !== '' || formValues.conceptNo !== '') {
      setUnsavedChanges(true);
      return;
    }
    setUnsavedChanges(false);
  };

  useEffect(() => {
    checkForUnsavedChanges();
  }, [formValues]);

  const handleRadioChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormValues({ ...formValues, frequencyNo: event.target.id });
  };
  
  const handleSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    const id = event.target.id;
    setFormValues({ ...formValues, [id]: event.target.value });
  };

  const handleSave = () => {
    setUnsavedChanges(false);
    mutate(
      {
        frequencyNo: formValues.frequencyNo,
        conceptNo: formValues.conceptNo,
        manInvRawProdId: formValues.manInvRawProdId,
      },
      {
        onSuccess: () => {
          navigateWithToast('/tables/mandatoryinventory', { label: 'New Mandatory Inventory Item has been added.', id: 'AddManInvItemSuccess' });
        },
        onError: (error) => {
          if ((error as AxiosError).message === 'Request failed with status code 409') {
            showToast({
              id: 'addManInvItem409',
              label: 'The selected Mandatory Inventory Item is currently in use.',
              toastType: ToastTypes.Error,
            });
          } else if ((error as AxiosError).message === 'apiGatewayTimeout') {
          } else {
            showToast({ ...genericErrorShowToastOptions, id: 'addManInvItemOtherError' });
          }
        },
      }
    );
  };

  return (
    <>
      <ManInvRawProdForm
        handleSelect={handleSelect}
        onFrequencyChange={handleRadioChange}
        onSave={handleSave}
        formValues={formValues}
        rawProdOptions={rawProdOptions}
        isSaveLoading={isSaveLoading}
        saveButtonDisabled={formValues.frequencyNo === '' || formValues.manInvRawProdId === '' || formValues.conceptNo === ''}
      />
      <UnsavedChangesModal unsavedChangesExist={unsavedChanges} />
    </>
  );
};

export default AddManInvRawProd;
